export default "__VITE_ASSET__BIQqRGvH__"